import React from "react";
var __jsx = React.createElement;
import { InfoScreen } from "@/pages/checkout/bnpl/common/components/InfoScreen";
import { useTranslation } from "@i18n";
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
import useHelpers from "@hooks/useHelpers";
import { useEffect } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
var WarrantyPaymentFailedPage = function WarrantyPaymentFailedPage() {
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    tShort = _useTranslation.tShort;
  var webview = useWebView();
  var isWebView = useIsWebView();
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  useEffect(function () {
    webview.showTitleBar(false)["catch"](function () {});
  }, [isWebView]);
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    disableLoader: true,
    headHideLinks: true,
    authenticationMsg: true,
    hideFooterWithoutAuthMsg: true,
    hideMenu: true,
    hideAppBanner: true,
    hideHeaderOnmobile: isWebView,
    mainClass: "flex flex-col"
  }, /*#__PURE__*/React.createElement(InfoScreen, {
    fullScreen: false,
    icon: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "94",
      height: "80",
      viewBox: "0 0 94 80",
      fill: "none"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Group"
    }, /*#__PURE__*/React.createElement("path", {
      id: "Path",
      opacity: "0.4",
      d: "M93.8965 32.5823V46.8076C93.8965 70.5165 84.5068 80 61.0327 80H32.8638C9.38965 80 0 70.5165 0 46.8076V32.5823C0 12.676 6.6197 2.8169 22.6291 0.140845H23.4741L70.4224 0C87.0421 2.44131 93.8965 12.3474 93.8965 32.5823Z",
      fill: "#FCC2C8"
    }), /*#__PURE__*/React.createElement("g", {
      id: "history"
    }, /*#__PURE__*/React.createElement("path", {
      id: "Path_2",
      d: "M45.7824 13.0486C52.7956 13.0486 54.4938 13.2495 57.0635 13.5514C57.7465 13.6317 58.5139 13.7237 59.4461 13.8183L59.5516 13.8286C60.2371 13.9004 60.9127 14.0455 61.5662 14.2614L61.6981 14.3055L61.7983 14.3418H61.8141L61.8312 14.3482C64.8099 15.418 67.0403 17.8898 67.7645 20.9241L67.8884 22.0902C68.2062 25.1015 68.4593 29.643 68.5899 34.9245C68.6293 36.5843 70.012 37.9086 71.7015 37.9046C72.5805 37.9012 73.4218 37.5536 74.0393 36.9389C74.6567 36.3241 74.9993 35.4928 74.9912 34.629C74.9292 26.5955 74.2608 21.4501 74.2608 21.4501C73.6413 15.5709 69.6687 10.5518 64.0226 8.51485C63.8762 8.46172 63.7299 8.40989 63.5822 8.35936C62.4883 7.998 61.3573 7.75597 60.2095 7.63764L60.1 7.62598C55.7187 7.18413 55.0159 6.8291 45.7824 6.8291C36.5529 6.8291 35.0591 7.18413 30.6803 7.63116L30.5709 7.64282C29.366 7.76719 28.1799 8.02807 27.036 8.42026V8.36066C21.2109 10.3068 17.0719 15.4076 16.4379 21.4216C15.8894 26.6046 15.6099 31.6022 15.6099 39.6189C15.6099 47.6356 15.8894 52.6345 16.4379 57.8174C17.2102 65.107 23.0728 70.8684 30.4905 71.6273L30.5999 71.6377C34.4143 72.0264 35.4388 72.3478 41.7478 72.4229C42.5873 72.433 43.3965 72.1147 43.9971 71.5383C44.5978 70.9618 44.9407 70.1745 44.9505 69.3494C44.9697 67.6439 43.5873 66.2414 41.852 66.206C37.7449 66.1231 35.2595 65.9067 33.6325 65.7149C32.9508 65.6346 32.1821 65.5439 31.2512 65.4493L31.1458 65.4376C26.7043 64.9842 23.1938 61.5343 22.7324 57.1696C22.2564 52.6747 21.9413 47.9699 21.9413 39.615C21.9413 31.2601 22.2591 26.5566 22.7324 22.0617C23.0703 18.8454 25.0931 16.036 28.0671 14.6527L29.1113 14.2951C29.7941 14.0609 30.5019 13.9044 31.2209 13.8286L31.3343 13.8183C32.0463 13.7444 32.67 13.6757 33.2725 13.6097C36.3301 13.2715 38.3501 13.0486 45.7811 13.0486",
      fill: "#FFA3AD"
    }), /*#__PURE__*/React.createElement("path", {
      id: "Shape",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M44.4456 56.1804C44.4456 65.5485 52.201 73.17 61.7351 73.17C71.2678 73.17 79.0246 65.5498 79.0246 56.1804C79.0246 46.8109 71.2678 39.1895 61.7351 39.1895C52.1906 39.1995 44.4557 46.8007 44.4456 56.1804ZM50.7744 56.1804C50.7744 50.2315 55.6817 45.409 61.7351 45.409C67.7858 45.4154 72.6893 50.2342 72.6958 56.1804C72.6958 62.1293 67.7885 66.9518 61.7351 66.9518C55.6817 66.9518 50.7744 62.1293 50.7744 56.1804Z",
      fill: "#FFA3AD"
    }), /*#__PURE__*/React.createElement("g", {
      id: "Group 5"
    }, /*#__PURE__*/React.createElement("path", {
      id: "Path_3",
      d: "M55.5053 54.781C54.2788 53.5545 54.2616 51.5831 55.467 50.3778C56.6723 49.1724 58.6437 49.1896 59.8702 50.4161L66.6449 57.1907C67.8714 58.4173 67.8885 60.3886 66.6832 61.594C65.4779 62.7993 63.5065 62.7821 62.28 61.5556L55.5053 54.781Z",
      fill: "#FFA3AD"
    }), /*#__PURE__*/React.createElement("path", {
      id: "Path_4",
      d: "M62.2801 50.4155C63.5066 49.189 65.478 49.1718 66.6833 50.3771C67.8886 51.5825 67.8714 53.5539 66.6449 54.7804L59.8703 61.555C58.6438 62.7815 56.6724 62.7987 55.4671 61.5934C54.2617 60.388 54.2789 58.4166 55.5054 57.1901L62.2801 50.4155Z",
      fill: "#FFA3AD"
    })), /*#__PURE__*/React.createElement("path", {
      id: "Path_5",
      d: "M30.9189 24.082H59.6965C61.4064 24.1165 62.7742 25.4885 62.7742 27.1691C62.7742 28.8498 61.4064 30.2218 59.6965 30.2562H30.9189C29.2091 30.2218 27.8413 28.8498 27.8413 27.1691C27.8413 25.4885 29.2091 24.1165 30.9189 24.082Z",
      fill: "#FFA3AD"
    }), /*#__PURE__*/React.createElement("path", {
      id: "Path_6",
      d: "M30.919 43.4619C29.1844 43.4619 27.7783 42.0801 27.7783 40.3755C27.7783 38.6709 29.1844 37.2891 30.919 37.2891H47.3291C49.0636 37.2891 50.4697 38.6709 50.4697 40.3755C50.4697 42.0801 49.0636 43.4619 47.3291 43.4619H30.919Z",
      fill: "#FFA3AD"
    })))),
    title: tShort("warranty/payment_failed_title"),
    text: tShort("warranty/payment_failed_description"),
    primaryButton: {
      label: tShort("warranty/back_to_track_order"),
      onClick: function onClick() {
        webview.openScreen("tracking_order", {})["catch"](function () {
          navigateToHard("/tracking-landing");
        });
      }
    }
  }));
};
export default WarrantyPaymentFailedPage;